import { formatWeekdayDateOrDash } from "@shared-core/domain/formatters";
import { Card } from "../../app/components/primitives/card";
import { Mail } from "lucide-react";

// The Notes tab, the same on the quote and the order page (Ben, 5 Oct): the
// messages from us (on a quote, the sender's note that came with it), then
// who to ask (a quote's sender; an order's contact, the customer's CSR).

export interface NoteMessage {
  key: string;
  from: string;
  at: string | null;
  text: string;
}

export function NotesPanel({
  messages,
  questionsHeading,
  contact,
  contactLine,
  noContact,
}: {
  messages: NoteMessage[];
  questionsHeading: string;
  /** Null: nobody on record to name. */
  contact: { name: string; email: string } | null;
  contactLine: string | null;
  /** What to say when nobody is on record; absent, the emailed link's "reply to the email we sent you". */
  noContact?: React.ReactNode;
}) {
  return (
    <div className="space-y-4">
      {messages.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          No messages from us yet.
        </p>
      ) : (
        messages.map((m) => (
          <Card key={m.key} className="gap-2 p-5">
            <p className="text-sm font-semibold">
              {m.from}
              {m.at && (
                <span className="font-normal text-muted-foreground">
                  {" "}
                  · {formatWeekdayDateOrDash(m.at)}
                </span>
              )}
            </p>
            <p className="whitespace-pre-wrap text-sm text-muted-foreground">
              {m.text}
            </p>
          </Card>
        ))
      )}
      <Card className="gap-1 p-5 text-sm">
        <p className="font-medium">{questionsHeading}</p>
        {contactLine && <p className="text-muted-foreground">{contactLine}</p>}
        {contact ? (
          <a
            href={`mailto:${contact.email}`}
            className="inline-flex items-center gap-1.5 text-primary hover:underline"
          >
            <Mail className="size-4" />
            {contact.name} · {contact.email}
          </a>
        ) : (
          (noContact ?? (
            <p className="text-muted-foreground">
              Reply to the email we sent you and we&apos;ll help.
            </p>
          ))
        )}
      </Card>
    </div>
  );
}
